import { Play, GraduationCap, BookOpen, Leaf, Gamepad2, Tv, Music, Sparkles, Brain, Library, Star, Flame, Swords, ScrollText, MessageCircle, Landmark, Youtube } from 'lucide-react';

export const navGroups = [
  {
    id: 'watch',
    label: 'Watch',
    icon: Play,
    blurb: '400+ videos: satire, music, essays and stories.',
    items: [
      { to: '/videos', label: 'Video Library', desc: 'Browse everything by series', icon: Play },
      { href: 'https://youtube.com/playlist?list=PLn8UbQXnz_ExF9R4UwNlqHAHF-d7OM24V', label: 'The Who Cares News™', desc: 'Satirical broadcast', icon: Tv },
      { href: 'https://www.youtube.com/playlist?list=PLn8UbQXnz_EwxLHHytTn17kdp69kZBNvn', label: 'GradTrax Music', desc: 'Original tracks & videos', icon: Music },
      { href: 'https://youtube.com/playlist?list=PLn8UbQXnz_EwRgkLIlru3qUNH_7XQs8kf', label: 'What the Fairy Tale', desc: 'Folklore, decoded', icon: Sparkles },
      { href: 'https://youtube.com/@mgn1.6', label: 'YouTube Channel', desc: 'mGn1.6 Radio with Grad Fawkes', icon: Youtube },
    ],
  },
  {
    id: 'learn',
    label: 'Learn',
    icon: GraduationCap,
    blurb: 'Education built by a published sociologist.',
    items: [
      { to: '/educators', label: 'Clear Lesson Studio', desc: 'Custom lesson packs for educators', icon: GraduationCap },
      { to: '/courses', label: 'Courses', desc: 'Sociology & social science', icon: Library },
      { to: '/truth-is-verb', label: 'Truth Is a Verb', desc: 'The PPC framework', icon: Brain },
      { to: '/faq', label: 'Low FAQs', desc: 'Questions, answered sideways', icon: MessageCircle },
    ],
  },
  {
    id: 'stories',
    label: 'Stories',
    icon: BookOpen,
    blurb: 'Mythic cosmology, books and the Dark Pan saga.',
    items: [
      { to: '/publications', label: 'All Publications', desc: 'Books, chapters & essays', icon: BookOpen },
      { to: '/publications/star-compass', label: 'Oumuamua: Star-Sung Compass', desc: 'Book 1 — on Amazon', icon: Star, tag: 'NEW' },
      { to: '/publications/blue-flame', label: 'Oumuamua: Blue Flame', desc: 'Book 2 — coming soon', icon: Flame, tag: 'NEW' },
      { to: '/dark-pan', label: 'The Dark Pan Saga', desc: 'Neverland is a job site', icon: ScrollText },
      { to: '/stone-initiative', label: 'Stone Initiative', desc: 'The Global Stone Act', icon: Landmark },
    ],
  },
  {
    id: 'nutrition',
    label: 'Nutrition',
    icon: Leaf,
    blurb: 'CocoaLife™ — a daily truffle with 102 minerals.',
    items: [
      { to: '/cocoalife', label: 'CocoaLife™', desc: 'The OSU capstone truffle', icon: Leaf },
      { to: '/order-cocoalife', label: 'Order CocoaLife™', desc: 'Reserve your supply', icon: Sparkles },
    ],
  },
  {
    id: 'play',
    label: 'Play',
    icon: Gamepad2,
    blurb: 'Free browser games from the MGN1.6 universe.',
    items: [
      { to: '/games', label: 'Games Hub', desc: 'Everything playable', icon: Gamepad2 },
      { to: '/game', label: 'Anunnaki vs Humans', desc: 'Choose your side', icon: Swords },
      { to: '/games/quiz', label: 'Contract of Ascension', desc: 'The gnostic quiz', icon: ScrollText },
      { to: '/games/music-gauntlet', label: 'Lines and Lyrics', desc: 'The Music Gauntlet — name that song', icon: Music },
    ],
  },
];

export const navSingles = [
  { to: '/shop', label: 'Shop' },
  { to: '/about', label: 'About' },
];

export const isGroupActive = (group, pathname) =>
  group.items.some((item) => item.to && (pathname === item.to || (item.to !== '/' && pathname.startsWith(item.to + '/'))));
